// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { miniContactUsStyles } from "@steiner/App/Components/MiniContactUs/MiniContactUs";
import LiveChat from "@steiner/XDL/Icons/LiveChat";
import Mail from "@steiner/XDL/Icons/Mail";
import Pdf from "@steiner/XDL/Icons/Pdf";
import Phone from "@steiner/XDL/Icons/Phone";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

miniContactUsStyles.container = {
    css: css`
        padding: 16px 12px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

const sharedLinkStyles = (iconSrc: IconPresentationProps["src"]): LinkPresentationProps => ({
    icon: {
        iconProps: {
            size: 12,
            src: iconSrc,
        },
    },
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.semiBold,
    },
    css: css`
        align-self: baseline;
    `,
});

miniContactUsStyles.phoneLink = {
    ...sharedLinkStyles(Phone),
};

miniContactUsStyles.liveChatLink = {
    ...sharedLinkStyles(LiveChat),
};

miniContactUsStyles.emailLink = {
    ...sharedLinkStyles(Mail),
};

miniContactUsStyles.creditApplicationLink = {
    ...sharedLinkStyles(Pdf),
};
